import { render, staticRenderFns } from "./FlightBulkUpdate.vue?vue&type=template&id=61cc0436"
import script from "./FlightBulkUpdate.vue?vue&type=script&lang=js"
export * from "./FlightBulkUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports